<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="pageinfo.banner" /></div>
            <div class="sloganwrap realwrap"><div class="sloganboxcollege realwrap"><div class="slogancollege"><span v-html="$common.langinfo(pageinfo.content,pageinfo.content_en)"></span></div></div></div>
        </div>
        <div class="infowrapcollege">
            <div class="infotypecollege" v-for="item in infolist" :key="item.id">
                <div class="infobox realwrap">
                    <div class="title"><div class="word"><span>{{$common.langinfo(item.title,item.title_en)}}</span></div><div class="line"><span></span></div></div>
                    <ul class="levellist">
                        <li v-for="(item2,index2) in item.x_children" :key="item2.id">
                            <dl class="levelitem">
                                <dt><img :src="item2.cover" /></dt>
                                <dd>
                                    <a class="a" :href="item2.url" target="_blank" v-if="item2.url">{{$common.langinfo(item2.title,item2.title_en)}}</a>
                                    <span class="a" v-else>{{$common.langinfo(item2.title,item2.title_en)}}</span>
                                    <span class="b" v-html="$common.langinfo(item2.content,item2.content_en)"></span>
                                    <span class="c">
                                        <a href="#" @click="item2.x_showmore=!item2.x_showmore; item2.x_isfirst=false">
                                            {{item2.x_showmore?$common.dicword('hidecourse'):$common.dicword('showcourse')}}<i :class="['iconfont',' icon-zhedie1',item2.x_isfirst?'': item2.x_showmore ? 'transitionrotate':'transitionrotateback']"></i>
                                        </a>
                                    </span>
                                </dd>
                            </dl>
                            <transition name="slidedown">
                                <div class="courselistwrap" v-show="item2.x_showmore">
                                    <div class="courselist">
                                        <dl v-for="(item3,index3) in item2.x_children" :key="item3.id">
                                            <dt><span>{{$common.langinfo(item.coursetitle,item.coursetitle_en)}}&nbsp;{{ pageinfo.alias=='teng'? (index2*item2.x_children.length+ index3+1): (index3+1)}}</span></dt>
                                            <dd><a href="#" @click="showvideo(item3)">{{item3.title}}<i v-if="item3.video" class="iconfont icon-shipinbofang-copy"></i></a><a href="#" v-if="item3.title_en" @click="showvideo(item3)">{{item3.title_en}}</a></dd>
                                        </dl>
                                    </div>

                                </div>
                            </transition>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

        <div class="infowrap2" v-for="item in homelist" :key="item.id">
            <div class="infotype1" v-if="item.infotypekv==1">
                <div class="infobox realwrap">
                    <div class="title"><div class="word"><span>{{$common.langinfo(item.title,item.title_en)}}</span></div><div class="line"><span></span></div></div>
                    <div class="content editor"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                </div>
            </div>
            <div class="infotype2" v-else-if="item.infotypekv==2">
                <div class="infobox realwrap" @mousemove="item.x_options.isstop=true" @click="item.x_options.isstop=true" @mouseout="item.x_options.isstop=false">
                    <div class="title"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div><div class="line"><span></span></div></div>
                    <div class="swiper"><ffswiper :infolist="item.x_children" :options="item.x_options" :indexcur.sync="item.x_indexcur" :direct.sync="item.x_direct"></ffswiper></div>
                    <div class="swiperbtn"><a href="#" @click="item.x_indexcur--;item.x_direct=2"><i class="iconfont icon-fanye"></i></a><a href="#" @click="item.x_indexcur++;item.x_direct=1"><i class="iconfont icon-fanye1"></i></a></div>
                </div>
            </div>
            <div class="infotype3" v-else-if="item.infotypekv==3">
                <div class="infobox realwrap" @mousemove="item.x_options.isstop=true" @click="item.x_options.isstop=true" @mouseout="item.x_options.isstop=false">
                    <div class="title"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div><div class="line"><span></span></div></div>
                    <div class="swipercon">
                        <div class="swiperleft"><a href="#" @click="item.x_indexcur--;item.x_direct=2"><i class="iconfont icon-fanye"></i></a></div>
                        <div class="swiper"><ffswiper :infolist="item.x_children" :options="item.x_options" :indexcur.sync="item.x_indexcur" :direct.sync="item.x_direct"></ffswiper></div>
                        <div class="swiperright"><a href="#" @click="item.x_indexcur++;item.x_direct=1"><i class="iconfont icon-fanye1"></i></a></div>
                    </div>

                </div>
            </div>
            <div class="infotype4" v-else-if="item.infotypekv==4">
                <div class="infobox realwrap">
                    <div class="title"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div><div class="line"><span></span></div></div>
                    <ul class="infocollege">
                        <li v-for="item in collegelist" :key="item.id">
                            <dl>
                                <dt><router-link :to="item.url"><img :src="item.cover" /></router-link></dt>
                                <dd>
                                    <span class="a"> <router-link :to="item.url"><img :src="item.logo" /></router-link></span>
                                    <span class="b"> <router-link :to="item.url">{{$common.langinfo(item.title,item.title_en)}}</router-link></span>
                                    <span class="c"> <router-link :to="item.url">{{$common.dicword('gonow')}}</router-link></span>
                                </dd>
                            </dl>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <el-dialog v-if="isshowvideo && videourl" :visible.sync="isshowvideo" top="0px" class="mydialog">
            <div class="polyvvideowrap" v-if="ispolyv">

                <div class="polyvvideobg">
                    <div class="winmask" v-if="isshowmask"></div>
                    <div class="polyvvideo" id="polyvvideo"></div>
                </div>

            </div>
            <video v-else :src="videourl" controls autoplay controlslist="nodownload" @contextmenu.prevent="" :poster="videoposter"></video>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'college',
        data() {
            return {
                pageinfo: {},
                infolist: [],
                homelist: [],
                isshowvideo: false,
                videourl: '',
                videoposter: '',
                videocourseid: 0,
                ispolyv: false,
                isshowmask: true
            };
        },
        methods: {
            showvideo(course) {
                if (course.video) {

                    this.ispolyv = course.video.indexOf('.mp4') <= 0;
                    this.videourl = course.video;
                    this.videoposter = course.videoimg;
                    this.videocourseid = course.id;
                    this.isshowvideo = true;
                    if (this.ispolyv) {
                        this.initPolyv(this.loadPolyv);
                    }
                }
            },
            initPolyv(callback) {
                let vodPlayerJs = 'https://player.polyv.net/script/player.js';
                if (!window.polyvPlayer) {
                    const myScript = document.createElement('script');
                    myScript.setAttribute('src', vodPlayerJs);
                    myScript.onload = callback;
                    document.body.appendChild(myScript);
                } else {
                    callback();
                }
            },
            loadPolyv() {

                const polyvPlayer = window.polyvPlayer;
                let jsondata = {
                    'postdata': {
                        'api': 'polyv', 'act': 'polyvplay', 'id': this.videocourseid, 'data': { 'vid': this.videourl }
                    }, 'msg': ''
                };

                this.$common.post(jsondata, res => {

                    this.player = polyvPlayer({
                        'wrap': '#polyvvideo',
                        'width': '100%',
                        'height': '100%',
                        'full_page_screen': false,
                        'pictureInPicture': false,
                        'rightMenu': [],
                        'loading_bg_img': this.videoposter,
                        'vid': res.infodata.vid,
                        'playsafe': res.infodata.token,
                        'ts': res.infodata.ts,
                        'sign': res.infodata.sign
                    });

                    this.player.on('s2j_onPlayerInitOver', () => {
                        this.isshowmask = false;
                    });
                });
            }
        },
        mounted() {

            let alias = this.$route.params.sub;
            this.$common.fetch({ 'act': 'tc_college', 'exts': 'alias=' + alias }, res => {
                if (res.infodata.id > 0) {
                    this.$emit("settopcollegeid", res.infodata.id);
                    this.pageinfo = res.infodata;


                    this.$common.each(res.infodatalevel, (item) => {
                        item.x_children = res.infodatacourse.filter(item2 => item2.levelid == item.id);

                        item.x_showmore = false;
                        item.x_isfirst = true;
                    });
                    this.$common.each(res.infodataproject, (item) => {
                        item.x_children = res.infodatalevel.filter(item2 => item2.projectid == item.id);

                    });
                    this.infolist = res.infodataproject;

                    this.$common.each(res.infodatainfo, (item) => {
                        if (item.infotypekv == 2) {
                            item.x_children = [];
                            if (item.imgs) {
                                let imgs = item.imgs.split(',');
                                imgs.forEach((itemimg, indeximg) => {
                                    item.x_children.push({ 'id': indeximg, 'img': itemimg });
                                });
                            }
                        }
                        else {
                            item.x_children = res.infodatainfosub.filter(item2 => item2.infoid == item.id);
                        }

                        item.x_haschild = (this.$common.basic.chempty(item.x_children));
                        item.x_indexcur = 0;
                        item.x_options = { 'type': item.infotypekv == 2 ? 'image' : 'content', 'isautoplay': true, 'isstop': false };
                        item.x_direct = 1;
                    });
                    this.homelist = res.infodatainfo;
                }
                else {
                    this.$router.replace('/');
                }
            });
        }
    }
</script>
